import momentTZ from "moment-timezone";

import { convertToMultiDaySlots } from "./timezoneConversion";

const convertWorkingHourToLocal = (workingHours, providerTZ, originTZ) => {
  if (!workingHours) {
    return;
  }
  const providerStartOfWeek = momentTZ.tz(providerTZ).startOf("week").startOf("day");
  const localWorkingHours = {};
  const createNewSlot = (dayName) => {
    localWorkingHours[dayName] = {
      slots: [],
    };
  };
  const addToSlot = (dayName, value) => {
    if (value[0] === "00:00" && value[1] === "00:00") {
      return;
    }
    if (!Object.keys(localWorkingHours).includes(dayName)) {
      createNewSlot(dayName);
    }
    localWorkingHours[dayName].slots.push(value);
  };

  // add all time slots
  for (const workingDayName of Object.keys(workingHours)) {
    const workingDayObject = workingHours[workingDayName];
    const workingDayIndex = momentTZ(workingDayName, "dddd").day();
    // get the current working day as a momentTZ instance in the providers timezone
    const providerWorkingDay = providerStartOfWeek.clone().add(workingDayIndex, "day");

    for (const slot of workingDayObject.slots) {
      const startTime = momentTZ(slot[0], "HH:mm");
      const startDayTime = providerWorkingDay
        .clone()
        .set({
          hour: startTime.hour(),
          minute: startTime.minute(),
        })
        .tz(originTZ);

      const endTime = momentTZ(slot[1], "HH:mm");
      const endDayTime = providerWorkingDay
        .clone()
        .set({
          hour: endTime.hour(),
          minute: endTime.minute(),
        })
        .tz(originTZ);

      // ensures that multi-day events are handled correctly
      const multiDaySlots = convertToMultiDaySlots(startDayTime, endDayTime);

      multiDaySlots.forEach((slot) => {
        const startDay = slot.startTime.format("dddd");

        addToSlot(startDay, [slot.startTime.format("HH:mm"), slot.endTime.format("HH:mm")]);
      });
    }
  }

  // Slots were appended in input-processing order, so when a slot crosses midnight
  // and is split by convertToMultiDaySlots, the midnight-wrapping portion (e.g. "00:00–01:00")
  // could land after a later-starting slot (e.g. "21:00–23:59") on the same day.
  // Sort by start time so consumers receive slots in chronological order.
  for (const day of Object.values(localWorkingHours)) {
    day.slots.sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0));
  }

  return localWorkingHours;
};

export { convertWorkingHourToLocal };
